// extracted by mini-css-extract-plugin
export default {"order-details__footer":"OrderDetailsFooter_order-details__footer__Ez3LU"};